import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SharingDataService } from 'src/sharing-data.service';
import { Customer } from '../register/customer.model';
import { Address } from '../address/address.model';
import { RegisterService } from '../register/register.service';
import { getOtp } from './getOtpRequest';
import { AuthService } from '../../AuthService';
import { ViewProductService } from '../view-products/view-product.service';
import { Cart } from '../view-products/cart.model'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }

  ngOnInit(): void {
    // Your initialization logic here
   
    this.register = false;
    this.addAddress=false;
  
    this.isOtpModalVisible = false;
    this.CustomerFound = false;

    this.enteredOtp=false;
  }
  constructor(private router: Router,private sharingDataService : SharingDataService,private registerService: RegisterService, private authService : AuthService,private viewProductService : ViewProductService) {}
  register=false;
  customerId:any;
  GetCustomers:any;
  addAddress=false;
  addressPage=false;
  newCustomer: Customer = {
    CustomerName: '',
    EmailId: '',
    Contact: ''
  };

  
   cartItems: any =<Cart>{
      productDescription: '',
    productPrice: '',
    inStock: '',
    Gender : '',
    Category : '',
    productImage : '',
    Quantity : 0,
    productName:  '',
    CustomerId:0

  };

  getOtp:getOtp={
   mailId: ''
    }
    newAddedCustomer:any;
  otpNumber:any;
  isOtpModalVisible=false;
  registerButton(){
    console.log("button clicked");
    // this.showAboutComponent = true;
    this.router.navigate(['/register']);
  }

  getOtpNumberOnMail(){
    this.sharingDataService.getOtp(this.getOtp).subscribe({
      next:(response) => {
        console.log('Otp response', response);
        this.otpNumber=response;
      }
    });
  }

  syncNames() {
    this.getOtp.mailId = this.newCustomer.EmailId;
   console.log("to value is ",this.getOtp.mailId);
  }
  syncCustomerName(){
   // this.getOtp.name = this.newCustomer.customerName;
  //  console.log("to value is ",this.getOtp.name);
  }
  CustomerFound=false;
  GetOtp(){
    this.getOtpNumberOnMail();
    let enteredEmail:string;
   
    this.isOtpModalVisible = true;
    
 
  }
  enteredOtp:any;
  closeOtpModal() {
    this.isOtpModalVisible = false;
    this.enteredOtp = '';
  }
  submitOtp() {
    console.log('Entered OTP:', this.enteredOtp);
    this.addAddress=true;
    if(this.otpNumber == this.enteredOtp){
      console.log("logged in succesfully");
    }
    else 
    {
      alert("OTP doesn't matched");
    }
    // You can call your OTP verification API here

    this.closeOtpModal();
  }


loginAuthFn(){
  let maildId=this.newCustomer.EmailId;
  let otp=this.enteredOtp;
let enteredEmail:string
this.authService.login({maildId,otp}).subscribe({
  next: (res) => {
    localStorage.setItem('jwt', res.token);
    this.sharingDataService.GetAllCustomers().subscribe({
      next:(response) => {
        console.log('All Customers', response);
        console.log('newCustomer', this.newCustomer);
        enteredEmail=this.newCustomer.EmailId;
        this.GetCustomers=response;
        console.log("GetCustomers",this.GetCustomers);
        for (let i = 0; i < this.GetCustomers.length; i++) {
           console.log('Customer inside loop',this.GetCustomers[i].EmailId);
          if(((this.GetCustomers[i].EmailId).toLowerCase() == enteredEmail.toLowerCase())){
            console.log('Customer will login',this.GetCustomers[i].emailId);
           this.CustomerFound=true;
            this.customerId=this.GetCustomers[i].CustomerId;
            console.log('this.customerIdCustomer id is ',this.customerId);
            localStorage.setItem('customerId', this.customerId);
            this.sendValue();
             this.addressFn();
            //this.addAddress=true;  // This we can remove later on from here 
           // check if address details are there in table 
          }
         else 
         {
          console.log('Customer will register');
         
          
        // add customer details , then address  in table 
        
         }
         
        }
        if(!this.CustomerFound){
       //   this.addAddress=true;
          this.CustomerFound=false;
           console.log('In customer not found  block');
           console.log('newCustomer not found  block', this.newCustomer);
          this.registerService.CreateCustomer(this.newCustomer).subscribe({
            next:(response) => {
              console.log('Customer added:', response);
              this.newAddedCustomer=response
              this.customerId=this.newAddedCustomer.CustomerId;
              console.log('new custom customer id ',this.customerId);
              this.sendValue();
               this.addressFn();
               localStorage.setItem('customerId', this.customerId);
               this.syncCartAfterLogin();
              // this.sharingDataService.GetAllCustomers().subscribe({
              //   next:(response) => {
              //     console.log('All Customers', response);
              //     this.GetCustomers=response;
              //     console.log("enteredMobileNumber",enteredEmail);
              //     for (let i = 0; i < this.GetCustomers.length; i++) {
                  
                    
              //         this.customerId=this.GetCustomers[i].customerId;
                    
                    
                  
                   
              //     }
              //   }
              // });
            },
            error: (err) => {
              console.error('Error:', err);
            }
          });
        }
        else {
this.syncCartAfterLogin();
        }
          this.closeOtpModal();
     
        
        // if(this.GetCustomers.contact == enteredMobileNumber){
        //   console.log(' Matched')
        //   Matched=count+1;
        // }
        // else{
        //   console.log('Not Matched')
        // }
        // console.log('Matched count ', Matched);
      },
      error: (err) => {
        console.error('Error:', err);
      }
    });
  //  this.router.navigate(['/dashboard']);
  
  console.log('Login successful, token saved.',res.token);
  
  },
  error: (err) => {
    console.error('Login failed', err);
  }
});
}

syncCartAfterLogin() {
  const cart = JSON.parse(localStorage.getItem('cart') || '[]');
 
  if (cart.length > 0) {
    console.log('Cart from local storage:', cart);
this.cartItems=cart;
    for(let i=0;i< cart.length;i++){
       this.cartItems[i].CustomerId=this.customerId;
       this.cartItems
       delete this.cartItems[i].productId;
    }
    console.log('Add to cartItems before DB call',this.cartItems);

    this.viewProductService.AddToCart(this.cartItems).subscribe({
  next: (res) => {

    console.log('Response after adding to cart:',res);
    localStorage.removeItem('cart');
  }

      
     
    });
  }
}
  
sendValue() {
  this.sharingDataService.getloggedInCustomerId(this.customerId);
}

   addressFn() {
    console.log(" Address button clicked");
    this.addressPage = true;
    this.router.navigate(['/address']);
  }



 
  
  
}


